<template lang="html">
  <el-select v-model="channelId" :multiple="multiple" :placeholder="placeholder" clearable filterable @change="$emit('change',channelId)"
  remote
  reserve-keyword
  :remote-method="remoteMethod">
    <el-option
     v-for="item in channels"
     :key="item.id"
     :label="item.channelName"
     :value="item.id">
      <span style="float: left">{{ item.channelName }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.total }}</span>
   </el-option>
  </el-select>
</template>

<script>
import ChannelModel from '@/framework/models/channelModel'
export default {
  name: 'withdraw-channel-select',
  data: function () {
    return {
      channels: [],
      channelId: []
    }
  },
  props: {
    multiple: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    placeholder: {
      type: String,
      default: function () {
        return '请选择'
      }
    }
  },
  created: function () {
    this.findAllChannels()
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.findAllChannels(query)
        }, 200)
      } else {
        this.options = []
      }
    },
    clear: function () {
      this.channelId = []
    },
    setChannelIds: function (channelId) {
      this.channelId = channelId
    },
    findAllChannels: function (keyword) {
      let _this = this
      let params = {
        keyword: keyword
      }
      let listener = {
        success: function (dataInfo) {
          _this.channels = dataInfo.datas
        }
      }
      ChannelModel.findWithdrawChannels(_this, params, listener)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
